import { css } from '@emotion/react';
import { leading } from '../../styles/theme';

export const tiny = css`
  margin-top: ${leading.third};
`;

export const half = css`
  margin-top: ${leading.half};
`;
